<template>
  <div>
    <ApolloQuery
      :query="require('../graphql/ObrasServicosDetails.gql')"
      :clientId="client"
      :variables="{ entidade }"
      :skip="!entidade"
      :update="data => {
        var result = data.obrasServicosDetails.map(obraServico => {
          
          if (this.all && obraServico.url) {
            obraServico.url += '?all=true';
          }
          if (obraServico.apelido) {
            obraServico.descricao = obraServico.apelido
          }
          if (obraServico.id) {
            obraServico.id = parseInt(obraServico.id)
          }
          if (obraServico.numero) {
            obraServico.numero = parseInt(obraServico.numero)
          }
          obraServico.tipo = formatEnumLabel(obraServico.tipo)

          obraServico.percentualConcluido = this.$options.filters.numFormat(
                                            obraServico.progresso, '0.00%')
          delete obraServico.__typename
          return obraServico;
        })

        if (result.length) {
          this.ultima_modificacao = result[0].ultima_modificacao;
          result.forEach((obraServico) => {
            if (obraServico.ultima_modificacao > this.ultima_modificacao) { 
              this.ultima_modificacao = obraServico.ultima_modificacao;
            }
          })
        } else {
          this.ultima_modificacao = null;
        }

        var hasSecretaria = data.obrasServicosDetails.reduce((has, obra) => {
          return has || (obra.secretaria && obra.secretaria.length)
        }, false);
        (this.columns.filter(c => c.field == 'secretaria')[0] || {}).invisible = !hasSecretaria;

        this.updateMarkers(result);

        return result
      }"
      :debounce="500"
    >
      <template slot-scope="{ result: { loading, error, data } }">
        <!-- Loading -->
        <div v-if="loading">Listando Obras...</div>

        <!-- Error -->
        <div v-else-if="error">{{ error.message }}</div>

        <!-- Result -->
        <div v-else-if="data">
          <table style="width: 100%">
            <tr v-if="markers.length">
              <td colspan="4">
                <mapa :markers="markers">
                </mapa>
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td>
                <vue-blob-json-csv
                  @success="handleSuccess"
                  @error="handleError"
                  file-type="json"
                  file-name="obras"
                  :data="data"
                >
                  <b-button 
                     size="is-small"
                     icon-left="file">JSON</b-button>
                </vue-blob-json-csv>
              </td>
              <td>
                <vue-blob-json-csv
                  @success="handleSuccess"
                  @error="handleError"
                  file-type="csv"
                  file-name="obras"
                  delimiter=","
                  :data="data"
                >
                  <b-button 
                     size="is-small"
                     icon-left="file-csv">CSV</b-button>
                </vue-blob-json-csv>
              </td>
              <td ng-if="ultima_modificacao" class="text-right">
                Última Atualização: {{ ultima_modificacao | formatDate }}
              </td>
            </tr>
          </table>
          <b-table 
            ref="table"
            :data="data"
            :paginated="true"
            :per-page="10"
            :sort-icon-size="'is-small'"
            :pagination-position="'bottom'"
            :default-sort-direction="'desc'"
            :sticky-header="true"
            :height="'500px'"
            default-sort="data_inicio"
            detailed
            detail-key="id"
            :show-detail-icon="showDetailIcon">

            <template v-for="column in columns">
                <b-table-column :key="column.id" v-bind="column" v-if="!column.invisible">
                    <template
                        v-if="column.searchable && !column.numeric"
                        #searchable="props">
                        <b-select v-if="column.select"
                            v-model="props.filters[props.column.field]"
                            @click.native="atualizarMarkers"
                            @change.native="atualizarMarkers">
                            <option value="">Todos</option>
                            <option
                                v-for="option in column.selectOptions"
                                :value="option"
                                :key="option">
                                {{ option }}
                            </option>
                        </b-select>
                        <b-input v-else
                            v-model="props.filters[props.column.field]"
                            @keyup.native="atualizarMarkers"
                            @change.native="atualizarMarkers"/>
                    </template>
                    <template v-slot="props">
                      <span v-if="column.date">
                        {{ props.row[column.field] | formatDate }}
                      </span>
                      <span v-else-if="column.percentage">
                        {{ props.row[column.field] | numFormat('0.00%') }}
                      </span>
                      <span v-else-if="column.currency">
                        {{ props.row[column.field] | numFormat('$ 0,0.00') }}
                      </span>
                      <a v-else-if="column.details"
                        @click="props.toggleDetails(props.row)">
                        {{ props.row.descricao }}
                      </a>
                      <span v-else>
                        {{ props.row[column.field] }}
                      </span>
                    </template>
                    <template #empty>
                        <div class="has-text-centered">Nenhuma obra encontrada</div>
                    </template>
                </b-table-column>
            </template>

            <b-table-column field="url" label="" v-slot="props">
              <a :href="props.row.url" target="_blank">
                <b-icon
                  pack="fas"
                  icon="external-link-alt"
                  size="is-small">
                </b-icon>
              </a>
            </b-table-column>

            <template slot="detail" slot-scope="props">
              <obra-servico
                :id="props.row.id"
                :all="all"
                :entidade="entidade"
              ></obra-servico>              
            </template>

            <template #footer v-if="filterEmpty">
                <div class="has-text-centered">
                    Nenhuma obra encontrada para os filtros informados
                </div>
            </template>
          </b-table>
          <!-- <pre>
            {{
              data
            }}
          </pre> -->
        </div>

        <!-- No result -->
        <div v-else class="alert alert-warning">Listando Obras...</div>
      </template>
    </ApolloQuery>
  </div>
</template>

<script>
import { icon } from "leaflet";

export default {
  data() {
    return {
      columns: [
        { field: 'numero', label: 'Obra', searchable: true, sortable: true },
        { field: 'descricao', label: 'Descrição', searchable: true, sortable: true, details: true },
        { field: 'tipo', label: 'Tipo', searchable: true, sortable: true },
        { field: 'numero_contrato', label: 'Contrato', searchable: true, sortable: true },
        { field: 'valor_total', label: 'Valor Total', searchable: false, sortable: true, currency: true },
        // { field: 'cpf_cnpj', label: 'CNPJ', searchable: true, sortable: true },
        { field: 'nome_contratado', label: 'Contratado', searchable: true, sortable: true },
        // { field: 'data_inicio', label: 'Data Início', searchable: false, sortable: true, date: true },
        // { field: 'previsao_termino', label: 'Previsão Término', searchable: false, sortable: true, date: true },
        { field: 'progresso', label: 'Progresso', searchable: false, sortable: true, percentage: true },
        { field: 'secretaria', label: 'Secretaria', searchable: true, sortable: true, invisible: true },
        { field: 'situacaoDescricao', label: 'Situação', searchable: true, sortable: true,
          select: true,
          selectOptions: ["Aguardando Licitação", "Aguardando Ordem de Serviço",
                          "Em Andamento", "Paralisada/Suspensa", "Cancelada",
                          "Concluída", "Rescindida", "Fracassada", "Deserta",
                          "Revogada", "Anulada", "Em Planejamento"]
        }
      ],
      markers: [],
      ultima_modificacao: null,
      filterEmpty: false,
      showDetailIcon: true,
      iconParalisada: icon({
        iconUrl: "marker-icon-paralisada.png",
        iconSize:[25, 41],      // Largura e altura do seu ícone
        iconAnchor: [12.5, 41],  // Metade da largura (centralizado) e total da altura (base do pino)
        popupAnchor: [0, -41] 
      }),
      iconCancelada: icon({
        iconUrl: "marker-icon-cancelada.png",
        iconSize:[25, 41],      // Largura e altura do seu ícone
        iconAnchor: [12.5, 41],  // Metade da largura (centralizado) e total da altura (base do pino)
        popupAnchor: [0, -41] 
      }),
      iconConcluida: icon({
        iconUrl: "marker-icon-concluida.png",
        iconSize:[25, 41],      // Largura e altura do seu ícone
        iconAnchor: [12.5, 41],  // Metade da largura (centralizado) e total da altura (base do pino)
        popupAnchor: [0, -41] 
      }),
      iconPlanejamento: icon({
        iconUrl: "marker-icon-planejamento.png",
        iconSize:[25, 41],      // Largura e altura do seu ícone
        iconAnchor: [12.5, 41],  // Metade da largura (centralizado) e total da altura (base do pino)
        popupAnchor: [0, -41] 
      }),
      iconDefault: icon({
        iconUrl: "marker-icon.png",
        iconSize:[25, 41],      // Largura e altura do seu ícone
        iconAnchor: [12.5, 41],  // Metade da largura (centralizado) e total da altura (base do pino)
        popupAnchor: [0, -41] 
      })
    };
  },
  props: {
    entidade: {
      default: null,
      type: Number
    },
    all: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    client() {
      return this.all ? 'v2' : 'v1'
    }
  },
  components: {
    ObraServico: () => import('./ObraServico.vue'),
    Mapa: () => import('./Mapa.vue')
  },
  methods: {
    handleSuccess() {

    },
    handleError() {

    },
    updateMarkers(result) {
      this.filterEmpty = (result.length == 0)
      this.markers = result.filter(item => {
        return item.latitude && item.longitude
      }).map(item => {
        switch(item.situacao) {
          case 'PARALISADA_SUSPENSA':
            item.icon = this.iconParalisada
            break;
          case 'CANCELADA':
          case 'RESCINDIDA':
          case 'FRACASSADA':
          case 'DESERTA':
          case 'REVOGADA':
          case 'ANULADA':
            item.icon = this.iconCancelada
            break;
          case 'CONCLUIDA': 
            item.icon = this.iconConcluida
            break;
          case 'EM_PLANEJAMENTO':
          case 'AGUARDANDO_LICITACAO':
            item.icon = this.iconPlanejamento
            break;
          case 'AGUARDANDO_ORDEM_SERVICO':
          case 'EM_ANDAMENTO':
          default:
            item.icon = this.iconDefault;
        }
        return item
      })
    },
    atualizarMarkers() {
      let table = this.$refs.table
      this.$nextTick(() => {
        this.updateMarkers(table.newData);
      });
    },
    showMap(lat, lng) {
      return (lat && lng)
    },
    formatEnumLabel(enumName) {
      return this.$options.filters['formatEnumLabel'](enumName)
    }
  }
};
</script>